
import axios from 'axios';
import dotenv from 'dotenv';

 import *as actionTypes from '../constants/cartConstant';
 dotenv.config();
 const URL=process.env.REACT_APP_BASE_URL;
export const addToCart=(id,quantity=1)=>async(dispatch)=>{

    try{
    const {data} = await axios.get(`${URL}/product/${id}`);
    console.log(data)
 
    dispatch({type:actionTypes.ADD_TO_CART,payload:{...data,quantity}}); 

}catch(error)
    {
         dispatch({type:actionTypes.ADD_TO_CART_ERROR,payload:error.message});
    }

    // localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems))
}

export const removeFromCart=(id)=>(dispatch)=>{

    dispatch({type:actionTypes.REMOVE_FROM_CART,payload:id});

}


export const updateCartItemQuantity = (itemId, quantity)=>(dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CART_ITEM_QUANTITY,
      payload: {
        itemId,
        quantity
      }
        
    });
  };
  